export const pkg = {
  name: 'isomorphic-git',
  version: '1.38.5',
  agent: 'git/isomorphic-git@1.38.5',
}
